import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { searchSpotifyTracks } from '../api/client.js';
import { suggesterSearchQueryKey } from '../api/queryKeys.js';

import type { PartySlug, SearchResults, SuggesterToken } from '@mixwire/contracts';

// Expects an already-debounced term. staleTime: 0 since a result's `alreadySuggested` can flip
// the moment anyone in the room presses Suggest — a cached answer could show it as still suggestable.
export const useSuggesterSearch = (
  slug: PartySlug,
  token: SuggesterToken,
  term: string,
): UseQueryResult<SearchResults> =>
  useQuery({
    queryKey: suggesterSearchQueryKey(slug, term),
    queryFn: async () => searchSpotifyTracks(slug, token, term),
    enabled: term !== '',
  });
